import React, { useState } from "react";

function extractId(url) {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]{6,})/);
  return m ? m[1] : null;
}

export function YouTubeEmbed({ url, title = "Video" }) {
  const [play, setPlay] = useState(false);
  const id = extractId(url);
  if (!id) return null;
  const thumb = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
  return (
    <div className="relative w-full overflow-hidden rounded-xl border border-border bg-black" style={{ aspectRatio: "16/9" }}>
      {play ? (
        <iframe
          className="absolute inset-0 h-full w-full"
          src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
          title={title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen data-testid="youtube-iframe" />
      ) : (
        <button data-testid="youtube-play-button" onClick={() => setPlay(true)} aria-label={`Play ${title}`}
          className="group absolute inset-0 h-full w-full">
          <img src={thumb} alt={title} className="h-full w-full object-cover opacity-90" loading="lazy" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-[#C85A32] text-white shadow-lg transition group-hover:scale-110">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z" /></svg>
            </span>
          </span>
        </button>
      )}
    </div>
  );
}
